// @flow strict
import * as React from 'react';

const NextArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16">
      <path d="M0 0l7.5 7.505L0 15.011h4.104l7.5-7.506L4.104 0z" fill="#231F20" />
    </svg>
  );
};

export { NextArrow };
